export default "__VITE_ASSET__CbDbmb4I__"